import { MetricTypes } from "../../autogen/metrics";

export const LTV_CAC_METRICS = [
  MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
  MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND,
  MetricTypes.ALLTIME_CAC,
];
["Alltime", "One Month", "Three Month", "Six Month", "Twelve Month"].forEach((key) => {
  const metric = key.toUpperCase().replace(/[- ]/g, "_");
  LTV_CAC_METRICS.push(...[MetricTypes[`${metric}_ORDERS`]]);
  LTV_CAC_METRICS.push(...[MetricTypes[`${metric}_NET_REVENUE`]]);
  LTV_CAC_METRICS.push(...[MetricTypes[`${metric}_AOV`]]);
  LTV_CAC_METRICS.push(...[MetricTypes[`${metric}_FREQUENCY`]]);
  LTV_CAC_METRICS.push(...[MetricTypes[`${metric}_LTV`]]);
});
